module.exports = __webpack_public_path__ + "img/01-configuration.dcbdd8df.png";